import { Controller } from "@hotwired/stimulus"
import Cookies from "js-cookie"

COOKIE_NAME = "AllowCookies"

export default class extends Controller {
  connect() {
    if (!this.areCookiesAllowed()) {
      this.show()
    }
  }

  areCookiesAllowed() {
    return Cookies.get(COOKIE_NAME) === 'yes';
  }

  allow() {
    if (!DEBUG) {
      Cookies.set(COOKIE_NAME, 'yes', { expires: 365 })
      this.appendGACode()
    }
    this.hide()
  }

  reject() {
    if (!DEBUG) {
      Cookies.set(COOKIE_NAME, 'no', { expires: 365 })
    }
    this.hide();
  }

  hide() {
    this.element.classList.add('translate-y-full')
  }

  show() {
    setTimeout(() => {
      this.element.classList.remove('translate-y-full')
    }, 3000)
  }

  appendGACode() {
    if (DEBUG || !window.GA4) return
    const tagManagerScriptTag = document.createElement("script")
    const eventsScriptTag = document.createElement("script")
    tagManagerScriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${window.GA4}`
    tagManagerScriptTag.async = true
    eventsScriptTag.textContent = `window.dataLayer = window.dataLayer || [];\
      function gtag(){dataLayer.push(arguments);}\
      gtag("js", new Date());\
      gtag("config", "${window.GA4}", { page_location: "${window.location.href}", page_path: "${window.location.pathname + window.location.search}", page_title: "${document.title}" })`
    document.getElementsByTagName('head')[0].appendChild(tagManagerScriptTag)
    document.getElementsByTagName('head')[0].appendChild(eventsScriptTag)
  }
}
